module.exports = __webpack_public_path__ + "img/jacket-left-sub-setIn-hood.5704b98b.png";